/**
 * Servicio de tracking — Portal Cliente Menuee
 *
 * Responsabilidad: lectura del último pedido del cliente (P5.4: sessionStorage).
 *
 * En P5.5: obtenerPedido() consultará Supabase (pedidos + RLS).
 *
 * Qué nunca debe hacer:
 * - Recalcular montos ni estados.
 * - Invocar E6 ni crear pedidos.
 * - Polling ni WebSockets (P5.5+).
 */

import {
  leerUltimoPedidoLocal,
  leerPedidoLocalPorId,
} from "../mappers/pedidoMapper";

export const VISTA_PORTAL_KEY = "menuee_vista_portal";

/**
 * @typedef {'carta'|'confirmacion'|'estado'} VistaPortal
 */

/**
 * @returns {import('../mappers/pedidoMapper').PedidoConfirmacionView|null}
 */
export function obtenerUltimoPedido() {
  return leerUltimoPedidoLocal();
}

/**
 * @param {string} [pedidoId]
 * @returns {import('../mappers/pedidoMapper').PedidoConfirmacionView|null}
 */
export function obtenerPedido(pedidoId) {
  if (!pedidoId) {
    return obtenerUltimoPedido();
  }
  return leerPedidoLocalPorId(pedidoId);
}

/**
 * @returns {VistaPortal}
 */
export function leerVistaPortal() {
  try {
    const valor = sessionStorage.getItem(VISTA_PORTAL_KEY);
    if (valor === "confirmacion" || valor === "estado") {
      return "confirmacion";
    }
  } catch {
    // sessionStorage no disponible
  }
  return "carta";
}

/**
 * @param {VistaPortal} vista
 */
export function guardarVistaPortal(vista) {
  try {
    if (vista === "carta") {
      sessionStorage.removeItem(VISTA_PORTAL_KEY);
      return;
    }
    if (vista === "confirmacion" || vista === "estado") {
      sessionStorage.setItem(VISTA_PORTAL_KEY, "confirmacion");
    }
  } catch {
    // sessionStorage no disponible
  }
}

/**
 * Vista inicial al cargar: confirmación/estado solo si hay pedido persistido.
 *
 * @returns {VistaPortal}
 */
export function resolverVistaPortalInicial() {
  const vista = leerVistaPortal();
  if (vista === "carta") {
    return "carta";
  }
  if (obtenerUltimoPedido()) {
    return vista;
  }
  guardarVistaPortal("carta");
  return "carta";
}
